import request from "@/utils/request";

// 列表(主数据列表)
export function loadMaterialsDemandListDataApi(data) {
  return request({
    url: "web/materialsDemand/listData",
    method: "post",
    data,
  });
}
// 导出
export function loadMaterialsDemandExportDataApi(data) {
  return request({
    url: "web/materialsDemand/exportData",
    method: "post",
    data,
  });
}
// 初始化
export function initMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/init",
    method: "post",
    data,
  });
}
// 新增或修改
export function saveMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/save",
    method: "post",
    data,
  });
}
// 作废
export function removeMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/remove",
    method: "post",
    data,
  });
}
// 提交
export function submitMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/submit",
    method: "post",
    data,
  });
}
// 审核
export function auditMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/audit",
    method: "post",
    data,
  });
}
// 撤销
export function revokeMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/revoke",
    method: "post",
    data,
  });
}
// 获取待处理申请数量
export function countTodoMaterialsDemandApi(data) {
  return request({
    url: "web/materialsDemand/countTodoData",
    method: "post",
    data,
  });
}
